import { Button } from 'antd'
import './lily-button.css'

const LilyButton = (props) => {
    const { text, loading, icon, className, onClick, style, size, type, disabled } = props
    return (
        <Button
            className={`${className} lily-button`}
            style={style || null}
            onClick={onClick}
            loading={loading}
            icon={icon || null}
            size={size || 'middle'}
            type={type || 'primary'}
            disabled={disabled || false}
        >
            {text || ''}
        </Button>
    )
}

export default LilyButton